import organisationApi from 'api/organisationsApi';
import Dispatcher from '../dispatcher/appDispatcher';
import { GET_ORGANISATION_SETTINGS } from 'constants/actionType';
import { parentShareApi } from '../api/2bap/parentShareApi';
import ActionType from '../constants/actionType';
import { objectivesApi } from '../api/objectivesApi';
import { assessmentCoverageApi } from '../api/2bap/admin/assessmentCoverageApi';
import { assessmentOverwriteAllJudgmentsApi } from '../api/2bap/admin/assessmentOverwriteAllJudgmentsApi';

class OrganisationSettingsAction {

  /**
   * @return {Promise<OrganisationSettingsModel>}
   */
  async getOrganisationSettings() {
    const settingsList = await organisationApi.getOrganisationSettings();
    Dispatcher.dispatch({
      actionType: GET_ORGANISATION_SETTINGS,
      settingsList
    });
    return settingsList;
  }

  async updateParentShareReviewProcessState(value, force = false) {
    const response = await parentShareApi.updateParentShareReviewProcessState(value, force);

    Dispatcher.dispatch({ actionType: ActionType.BUILD_A_PROFILE_MODULE_OBSERVATIONS_RELEASE_CLEAR_DATA });
    Dispatcher.dispatch({ actionType: ActionType.BUILD_A_PROFILE_MODULE_PARENT_SHARE_SETTINGS_CLEAR_DATA });
    Dispatcher.dispatch({ actionType: ActionType.BUILD_A_PROFILE_MODULE_PARENT_SHARE_CLEAR_PAGE_DATA });

    return response;
  }

  async setParentObjectivesVisibilitySetting(schoolId, settingValue) {
    const response = await objectivesApi.setParentObjectivesVisibilitySetting(schoolId, settingValue);

    Dispatcher.dispatch({ actionType: ActionType.ADMIN_OBSERVATION_OBJECTIVES_SET_PARENT_OBJECTIVES_VISIBILITY_SETTING });

    return response;
  }

  async setNextStepObjectivesVisibilitySetting(schoolId, settingValue) {
    const response  = await objectivesApi.setNextStepObjectivesVisibilitySetting(schoolId, settingValue);

    Dispatcher.dispatch({ actionType: ActionType.ADMIN_OBSERVATION_OBJECTIVES_SET_NEXT_STEP_OBJECTIVES_VISIBILITY_SETTING });

    return response;
  }

  async setManualJudgementSetting(value) {
    return assessmentCoverageApi.setManualJudgementRespect(value);
  }

  async setOverwriteAllJudgmentsSetting(value) {
    return assessmentOverwriteAllJudgmentsApi.overwriteAllJudgments(value);
  }

  async saveOrganisationSettings2bap(schoolId, settings) {
    return organisationApi.saveOrganisationSettings2bap(schoolId, settings);
  }

}

export const organisationSettingsActions = new OrganisationSettingsAction();
